// Redux
import { AsyncResult, Action, ApiAction } from '../index';
import api from '../redux-api';
import { replaceById } from '../../utils/objects';

// Types
import { AdvisorsState } from './types/advisors';
import AdvisorInfos from '@/types/advisor-infos';

// Initial state
const INITIAL_STATE: AdvisorsState = {
  advisors: [],
  loading: false,
};

// Actions
const GET_MY_ADVISORS: ApiAction = {
  type: 'connect/users/get-my-advisors',
  endpoint: 'users/my-advisors',
};

export const SET_ADVISOR_INFO: Action = {
  type: 'connect/advisors/set-advisor-info',
};

// Reducer
export default function reducer(state: AdvisorsState = INITIAL_STATE, action: Action): AdvisorsState {
  switch (action.type) {
    case GET_MY_ADVISORS.type: {
      return {
        ...state,
        loading: true,
      };
    }
    case `${GET_MY_ADVISORS.type}_SUCCESS`: {
      return {
        ...state,
        advisors: action.data.data,
        loading: false,
      };
    }
    case `${GET_MY_ADVISORS.type}_ERROR`: {
      return {
        ...state,
        loading: false,
      };
    }
    case `${SET_ADVISOR_INFO.type}`: {
      return {
        ...state,
        advisors: replaceById(state.advisors, action.payload.user, 'id'),
        loading: false,
      };
    }
    default: {
      return state;
    }
  }
}

// Action Creators
export const getMyAdvisors = (): AsyncResult<AdvisorInfos[]> => () => api.get(GET_MY_ADVISORS).then((res: { data: any }) => res.data);
